module.exports = __webpack_public_path__ + "img/sun.f5500b1b.svg";